<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="modal-window-content">
    <div class="siklu-mat-dialog-title" matDialogTitle>
        <h4>{{ 'project.houseDetection.title'  | translate }}</h4>
        <button (click)="closeModal()" matDialogClose windeClose>
            <sui-svg-icon icon="cross"/>
        </button>
    </div>

    <div class="siklu-mat-dialog-body" matDialogContent>
        <div class="control">
            <div>{{ ('project.houseDetection.duplicateDistance-' + projectUnits) | translate }}</div>
            <sui-number-component [config]="duplicateDistance" class="control-width sui-e2e-duplicateDistance"></sui-number-component>
        </div>

        <div class="control">
            <div>{{ ('project.houseDetection.areaThresholdLow-' + projectUnits) | translate }}</div>
            <sui-number-component [config]="areaThresholdLow" class="control-width sui-e2e-areaThresholdLow"></sui-number-component>
        </div>

        <div class="control">
            <div>{{ ('project.houseDetection.areaThresholdHigh-' + projectUnits) | translate }}</div>
            <sui-number-component [config]="areaThresholdHigh" class="control-width sui-e2e-areaThresholdHigh"></sui-number-component>
        </div>
    </div>
</div>
